import React from 'react';
import { Shield, DollarSign, Monitor, FileSearch, Users, Heart, Baby } from 'lucide-react';
import { Card } from './ui/card';

const iconMap = {
  Shield,
  DollarSign,
  Monitor,
  FileSearch,
  Users,
  Heart,
  Baby
};

const CommitmentsSection = ({ commitments }) => {
  return (
    <section id="commitments" className="commitments-section">
      <div className="section-container">
        <div className="section-label text-center">My Commitments</div>
        <h2 className="section-heading-center">Seven Pillars of Reform</h2>
        <p className="section-subtitle">
          Concrete actions for a stronger, more inclusive legal profession
        </p>

        <div className="commitments-grid">
          {commitments.map((commitment, index) => {
            const IconComponent = iconMap[commitment.icon];
            return (
              <Card key={index} className="commitment-card">
                <div className="commitment-icon-wrapper">
                  <IconComponent size={32} className="commitment-icon" />
                </div>
                <h3 className="commitment-title">{commitment.title}</h3>
                <p className="commitment-description">{commitment.description}</p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CommitmentsSection;
